const media = [
  { src: "/media/gameplay-court.svg", alt: "Seven athletes on the sunset basketball court" },
  { src: "/media/gameplay-launch.svg", alt: "An athlete flying toward the hoop" },
  { src: "/media/gameplay-menu.svg", alt: "Hoop Dreams start menu" },
];

export function renderStore(app: HTMLElement): void {
  app.innerHTML = `
    <div class="steam-page">
      <header class="steam-global-header">
        <div class="steam-global-inner">
          <a class="steam-logo" href="/store"><i></i><span>STEAM</span></a>
          <nav aria-label="Steam navigation">
            <a class="active" href="#">STORE</a><a href="#">COMMUNITY</a><a href="#">ABOUT</a><a href="#">SUPPORT</a>
          </nav>
          <div class="steam-account"><span>Install Steam</span> login&nbsp; | &nbsp;language</div>
        </div>
      </header>
      <div class="store-body">
        <nav class="steam-store-nav" aria-label="Store categories">
          <a href="#">Your Store</a><a href="#">New &amp; Noteworthy</a><a href="#">Categories</a><a href="#">Points Shop</a><a href="#">News</a><a href="#">Labs</a>
          <label><span class="sr-only">Search</span><input value="search the store" readonly><b>⌕</b></label>
        </nav>
        <main class="steam-content">
          <div class="steam-breadcrumb">All Games &gt; Indie Games &gt; Hoop Dreams</div>
          <div class="steam-title-row"><h1>Hoop Dreams</h1><a href="/">Community Hub</a></div>

          <section class="steam-hero">
            <div class="steam-gallery">
              <div class="steam-main-media"><img id="store-main-media" src="${media[0]?.src}" alt="${media[0]?.alt}"></div>
              <div class="steam-thumbnails">
                ${media.map((item, index) => `<button class="${index === 0 ? "active" : ""}" data-media="${index}" aria-label="Show screenshot ${index + 1}"><img src="${item.src}" alt=""></button>`).join("")}
              </div>
            </div>
            <aside class="steam-summary">
              <img class="steam-capsule" src="/media/key-art.svg" alt="Hoop Dreams key art">
              <p>Grab ’em. Launch ’em. Score. Master a deliberately ridiculous physics playground and send a full roster of hopeful athletes clean through the hoop before the final buzzer.</p>
              <dl>
                <dt>RECENT REVIEWS:</dt><dd>Overwhelmingly Positive <small>(420)</small></dd>
                <dt>ALL REVIEWS:</dt><dd>Very Positive <small>(6,969)</small></dd>
                <dt>RELEASE DATE:</dt><dd>3 Aug, 2026</dd>
                <dt>DEVELOPER:</dt><dd>Racial Detour</dd>
                <dt>PUBLISHER:</dt><dd>Shitgate Interactive</dd>
              </dl>
              <div class="steam-tags"><span>Physics</span><span>Basketball</span><span>Dark Humor</span><span>Arcade</span><span>Score Attack</span></div>
            </aside>
          </section>

          <div class="steam-columns">
            <div class="steam-main-column">
              <section class="steam-buy-box">
                <h2>Play Hoop Dreams</h2>
                <p>Includes the complete 60-second score attack</p>
                <div class="steam-buy-action"><span>Free To Play</span><a href="/">Play Game</a></div>
              </section>
              <button id="wishlist-button" class="wishlist-button">♡ Add to your wishlist</button>

              <article class="steam-panel steam-about">
                <h2>ABOUT THIS GAME</h2>
                <img src="/media/about-banner.svg" alt="One minute. One hoop. Unlimited potential.">
                <h3>Everybody has a dream. Some just need help getting off the ground.</h3>
                <p><strong>Hoop Dreams</strong> is a precision physics basketball score attack about finding the perfect release. Grab an athlete, build momentum, and let go at exactly the right angle. Bank it off the glass, scrape the rim, or thread a perfect swish.</p>
                <p>Every run lasts one minute. That is long enough to learn, short enough to demand one more attempt, and exactly enough time to discover that your throwing arm has betrayed you.</p>
                <div class="feature-grid">
                  <div><b>60</b><span>seconds per run</span></div>
                  <div><b>7</b><span>unique athletes</span></div>
                  <div><b>∞</b><span>bad launch angles</span></div>
                </div>
                <h3>Built for repeat runs</h3>
                <ul>
                  <li>Responsive mouse, pen, and touchscreen throwing</li>
                  <li>Fixed-step physics with velocity smoothing and sane power limits</li>
                  <li>Rim, backboard, bounce, swish, streak, and perfect-shot feedback</li>
                  <li>Persistent personal bests and instant restarts</li>
                  <li>Seven athletes with distinct skin tones, uniforms, hairstyles, and numbers</li>
                  <li>Fully responsive desktop and mobile presentation</li>
                </ul>
              </article>

              <article class="steam-panel">
                <h2>EARLY PLAYER REVIEWS</h2>
                <div class="review-card">
                  <div class="review-author"><b>Bart</b><span>0.8 hrs on record</span></div>
                  <div class="review-copy"><div>👍 Recommended</div><time>POSTED: 3 AUGUST</time><p>“AND THE PLAY BUTTON EVEN WORKS”</p></div>
                </div>
                <div class="review-card">
                  <div class="review-author"><b>BabyPowderDistributor</b><span>0.4 hrs on record</span></div>
                  <div class="review-copy"><div>👍 Recommended</div><time>POSTED: 3 AUGUST</time><p>“perfect. LMAOOO”</p></div>
                </div>
              </article>

              <article class="steam-panel mature-panel">
                <h2>MATURE CONTENT DESCRIPTION</h2>
                <p>The developers describe the content like this:</p>
                <blockquote>Contains cartoon slapstick and dark comedy involving stylized human characters being grabbed and launched through a basketball hoop. No blood, gore, or realistic injury is depicted.</blockquote>
              </article>
            </div>

            <aside class="steam-sidebar">
              <section class="steam-side-card feature-list">
                <a href="/"><i>▣</i> Single-player</a>
                <a href="/"><i>🏆</i> Personal bests</a>
                <a href="/"><i>☁</i> Local save data</a>
                <a href="/"><i>☝</i> Touch friendly</a>
                <a href="/"><i>⛶</i> Fullscreen</a>
              </section>
              <section class="steam-side-card">
                <h3>Is this game relevant to you?</h3>
                <p>Sign in to see reasons why you may or may not like this based on your games, friends, and curators you follow.</p>
              </section>
              <section class="steam-side-card language-card">
                <h3>Languages</h3>
                <table><thead><tr><th></th><th>Interface</th><th>Audio</th><th>Subtitles</th></tr></thead><tbody><tr><td>English</td><td>✔</td><td></td><td>✔</td></tr></tbody></table>
              </section>
              <section class="steam-side-card rating-card">
                <div class="rating-badge">18</div><p>Dark humor<br>Cartoon violence<br>Competitive athlete launching</p>
              </section>
              <section class="steam-side-card details-card">
                <p><b>Title:</b> Hoop Dreams</p><p><b>Genre:</b> Casual, Indie, Sports</p><p><b>Developer:</b> <a href="#">Racial Detour</a></p><p><b>Publisher:</b> <a href="#">Shitgate Interactive</a></p><p><b>Release Date:</b> 3 Aug, 2026</p>
              </section>
              <section class="steam-side-card links-card"><a href="/">Visit the website ↗</a><a href="#">View update history</a><a href="#">Read related news</a><a href="#">View discussions</a></section>
            </aside>
          </div>
          <footer class="steam-footer">Storefront concept for Hoop Dreams · Steam and the Steam logo are trademarks of Valve Corporation.</footer>
        </main>
      </div>
    </div>
  `;

  const mainMedia = app.querySelector<HTMLImageElement>("#store-main-media");
  const thumbnailButtons = [...app.querySelectorAll<HTMLButtonElement>("[data-media]")];
  for (const button of thumbnailButtons) {
    button.addEventListener("click", () => {
      const index = Number(button.dataset.media);
      const item = media[index];
      if (!item || !mainMedia) return;
      mainMedia.src = item.src;
      mainMedia.alt = item.alt;
      thumbnailButtons.forEach((candidate) => candidate.classList.toggle("active", candidate === button));
    });
  }

  app.querySelector("#wishlist-button")?.addEventListener("click", (event) => {
    const button = event.currentTarget as HTMLButtonElement;
    const selected = button.classList.toggle("selected");
    button.textContent = selected ? "✓ On your wishlist" : "♡ Add to your wishlist";
  });
}
